/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { ChangeDetectionStrategy, Component, input, output, signal } from '@angular/core';
import { DxFileUploaderModule } from 'devextreme-angular';

@Component({
  selector: 'app-single-file-upload',
  imports: [DxFileUploaderModule],
  templateUrl: './single-file-upload.component.html',
  styleUrl: './single-file-upload.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SingleFileUploadComponent {
  allowedFileExtensions = input<string[]>([]);
  maxFileSize = input<number>(0);
  dropZoneActive = signal(false);
  fileSelected = output<File>();

  onValueChanged($event: unknown): void {
    const files: File[] = $event['value'] as File[];
    if (files?.length === 1)
      this.fileSelected.emit(files[0]);
    this.dropZoneActive.set(false);
  }

  onDropZoneEnter({ component, dropZoneElement, event }: { component: any, dropZoneElement: HTMLElement, event: any }): void {
    if (dropZoneElement.id === 'upload-container') {
      const items: File[] = event.originalEvent.dataTransfer.items;

      const allowedFileExtensions: string[] = component.option('allowedFileExtensions');
      const draggedFileExtension = `.${items[0].type.replace(/^image\//, '')}`;

      const isSingleFileDragged = items.length === 1;
      const isValidFileExtension = allowedFileExtensions.includes(draggedFileExtension);

      if (isSingleFileDragged && isValidFileExtension) {
        this.dropZoneActive.set(true);
      }
      this.dropZoneActive.set(true);
    }
  }

  onDropZoneLeave({ dropZoneElement }: { dropZoneElement: HTMLElement }): void {
    if (dropZoneElement.id === 'upload-container') {
      this.dropZoneActive.set(false);
    }
  }
}
